import classnames from 'classnames';
import type { ConnectivityStateFE, DeviationSeverityFE } from 'domain/vehicle';
import { isConnectivityOffline, isConnectivityOnline } from 'helper/connectivity';
import { getRelativeTime } from 'helper/time';
import type React from 'react';
import { useRef } from 'react';

import './_styles.scss';

import { useClock } from 'hooks/useClock';

interface Props {
    severity?: DeviationSeverityFE;
    relativeTime?: string;
    vehicleIdentifier: string;
    isSelected?: boolean;
    className?: string;
    onClick?: () => void;
    icon?: React.ReactNode;
    connectivityState?: ConnectivityStateFE | null;
}

const VehicleCard = ({
    className,
    onClick,
    severity,
    relativeTime,
    vehicleIdentifier,
    icon,
    isSelected,
    connectivityState,
}: Props) => {
    const elementRef = useRef<HTMLDivElement>(null);
    const datetime = useClock();

    return (
        <div
            className={classnames(`VehicleCard ${className ?? ''}`, {
                'VehicleCard--active': isSelected,
                'VehicleCard--fatal': severity === 'FATAL',
                'VehicleCard--error': severity === 'ERROR',
                'VehicleCard--warning': severity === 'WARNING',
                'VehicleCard--stable':
                    !severity || (severity !== 'FATAL' && severity !== 'ERROR' && severity !== 'WARNING'),
            })}
            onClick={onClick}
        >
            <div
                ref={elementRef}
                className='VehicleCard__innerCard'
                data-testid={`vehicle-deviation-card-${vehicleIdentifier.toLowerCase()}`}
            >
                {icon}
                <p className='VehicleCard__datetime'>
                    {relativeTime ? `Since ${getRelativeTime(datetime, new Date(relativeTime))}` : 'Unknown'}
                </p>
                <p className='VehicleCard__identifier'>
                    <span className='VehicleCard__identifierText'>{vehicleIdentifier}</span>
                    <span
                        data-testid='vehicle-connectivity-icon'
                        className={classnames('VehicleCard__wifi rioglyph', {
                            'rioglyph-wifi VehicleCard__wifi--online': isConnectivityOnline(connectivityState),
                            'rioglyph-wifi-off VehicleCard__wifi--offline': isConnectivityOffline(connectivityState),
                        })}
                    />
                </p>
            </div>
        </div>
    );
};

export default VehicleCard;
